/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-08 09:56:15                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-10 16:04:02                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * ProspectsTable: prospects table section
*/

/* Imports */
import { useNavigate } from "react-router-dom";
import { t } from "../../../i18n";
/***/

/* Components */
import { Table } from "../../../components/table/Table";
import ProspectListItem from "../../../components/data/prospect/ProspectListItem";
/***/

/**
* ProspectsTable: prospects table section
* display prospects in table 
*/
export default function ProspectsTable({
  prospects,
  selectedHead,
  orderDesc,
  onHeadClick,
  onChange,
  isAdminComponent,
  customer
}: {
  prospects: EasyTech.Prospect[],
  selectedHead?: string,
  orderDesc?: boolean,
  onChange?: () => void,
  onHeadClick?: (head: string, orderDesc: boolean) => void,
  isAdminComponent?: boolean,
  customer?: EasyTech.Customer
}) {
  const navigate = useNavigate();
  const TABLE_HEAD: ({
    label: string,
    orderKey: string | null,
    width?: string
  }[]) = [
      {
        label: t("common:ref:label"),
        orderKey: "ref",
        width: "15%"
      }, {
        label: t("common:date:label"),
        orderKey: "date",
        width: "15%"
      }, {
        label: t("date:hour"),
        orderKey: "hour",
        width: "15%"
      }, {
        label: t("common:technician"),
        orderKey: "technician.user.lastName",
        width: "25%"
      }
    ];

  if (customer === undefined)
    TABLE_HEAD.push({
      label: t("common:customer"),
      orderKey: "customer.name",
      width: "20%"
    });

  TABLE_HEAD.push({
    label: t("common:contact"),
    orderKey: "contact.lastname",
    width: "10%"
  });
  if (isAdminComponent) TABLE_HEAD.push({ label: t("common:actions"), orderKey: null, width: "10%" });


  return (
    <Table tableHead={TABLE_HEAD} emptyTable={(!prospects || prospects.length === 0) ? t("prospect:noData") : false}
      selectedHead={selectedHead} orderDesc={orderDesc}
      onHeadClick={onHeadClick}
      enableRowLinks={true}>
      {prospects.map((p, i) => (
        <ProspectListItem key={p.id}
          prospect={p}
          onClick={() => navigate(`/visits/${p.id}`)}
          onChange={() => { if (onChange) onChange(); }}
          customer={customer}
          isLast={i === prospects.length - 1} isAdminComponent={isAdminComponent === undefined ? false : isAdminComponent} />
      ))}
    </Table>
  );
}
/***/
